import { selectParams, selectQueryString } from '@oneappexchange/lwc-wired';
import axios from 'axios';
import { PUBLISHING_SERVICE_URL } from '~/config';
import { routerStore } from '../stores/routerStore';
import { handleNetworkError, withVersionHeaders } from '../utilities/axiosUtilities';
export function getAPISolutionsAndPackages() {
  let url = `${PUBLISHING_SERVICE_URL}/publishing/solutions?`;
  const params = selectParams(routerStore.getState()) || {};
  url += params.sortBy ? `&sortBy=${params.sortBy}` : '';
  url += params.sortOrder ? `&sortOrder=${params.sortOrder}` : '';
  url += params.technology ? `&technology=${params.technology}` : '';
  url += params.reviewed ? `&reviewed=${params.reviewed}` : '';
  url += params.searchTerm ? `&searchTerm=${params.searchTerm}` : '';
  return axios.get(url, withVersionHeaders()).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function getVersionsByPackageId(packageId, limit, offset) {
  let url = `${PUBLISHING_SERVICE_URL}/publishing/solutions/packageId/${packageId}?`;
  const queryString = selectQueryString(routerStore.getState());
  const params = new URLSearchParams(queryString);
  if (params.has('sortBy')) {
    url += `&sortBy=${params.get('sortBy')}`;
  }
  if (params.has('sortOrder')) {
    url += `&sortOrder=${params.get('sortOrder')}`;
  }
  if (params.has('technology')) {
    url += `&technology=${params.get('technology')}`;
  }
  if (params.has('reviewed')) {
    url += `&reviewed=${params.get('reviewed')}`;
  }
  if (limit && offset) {
    url += `&limit=${limit}&offset=${offset}`;
  }
  return axios.get(url, withVersionHeaders()).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function getSolutionsByType(technology) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/solutions?${new URLSearchParams(technology ? {
    technology
  } : undefined)}`;
  return axios.get(url, withVersionHeaders()).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function getSolutionsById(id) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/solutions/${id}`;
  return axios.get(url, withVersionHeaders()).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function upsertSolution(solution) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/solution`;
  return axios.post(url, solution, withVersionHeaders()).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function getPackageSolutionId(packageId) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/solutions/packageVersions/${packageId}`;
  return axios.post(url, undefined, withVersionHeaders()).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function getTrialTemplateSolutionId(trialTemplateId) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/solutions/trialTemplates/${trialTemplateId}`;
  return axios.post(url, undefined, withVersionHeaders()).then(({
    data
  }) => data).catch(handleNetworkError);
}